/** Suspense fallback while lazy route chunks load — keep empty (no full-page skeletons). */
export default function RouteSuspenseFallback() {
  return null;
}
